// extracted by mini-css-extract-plugin
export default {"root":"Wallet_root__4LVjK","item":"Wallet_item__6ismc","price":"Wallet_price__Q76ra","label":"Wallet_label__U-ZEa","row":"Wallet_row__BvsOC","link":"Wallet_link__ZZB02"};